const router = [
    {
        path: '/remark/companyList',
        component: () => import('../views/Remark/CompanyList.vue'),
        beforeEnter(to, from, next) {
            document.title = '聊城房屋交易租赁平台';
            next()
        },
    },
    {
        path: '/remark/personList',
        component: () => import('../views/Remark/PersonList.vue'),
        beforeEnter(to, from, next) {
            document.title = '聊城房屋交易租赁平台';
            next()
        },
    },
]
export default router
